import HomeView from "./view/HomeView";
import SingleView from "./view/SingleView";
import VisionView from "./view/VisionView";
import ArticleCarousel from "./components/ArticleCarousel";
import ArticlesRelated from "./components/ArticlesRelated";
import Cover from "./components/Cover";
import TagsList from "./components/TagsList";
import PullquoteCustom from "./components/PullquoteCustom";
import QuoteVisual from "./components/QuoteVisual";
import IlluSide from "./components/IlluSide";
import IlluHighlight from "./components/IlluHighlight";
import Footer from "./components/Footer";
import TermsList from "./components/TermsList";
import CompoIntro from "./components/CompoIntro";
import PlayerVideo from "./components/Player";
import CompoIntroHomepage from "./components/homepage/CompoIntro";
import VideoDetection from "./components/VideoDetection";
import RevealGridItem from "./fx/RevealGridItem";
import RevealGridItemQuote from "./fx/RevealGridItemQuote";
import RevealGridItemEvent from "./fx/RevealGridItemEvent";

import CoverCreationsIndex from "./components/creations/CoverCreationsIndex";
import CoverSavoirFaire from "./components/savoirfaire/Cover";
import CoverEvents from "./components/events/Cover";
import CoverPeople from "./components/people/Cover";
import CoverVision from "./components/vision/Cover";
import Rail from "./components/people/Rail";
import RailHome from "./components/homepage/Rail";
import RailLab from "./components/homepage/RailLab";
import GridFilter from "./components/GridFilter";
import DatesList from "./components/DatesList";
import VisionSlideshow from "./components/vision/Slideshow";
import VisionAccordion from "./components/vision/Accordion";
import LabHighlight from "./components/homepage/LabHighlight";
import PeopleHighlight from "./components/homepage/PeopleHighlight";
import CompoSavoirFaire from "./components/homepage/CompoSavoirFaire";
import CompoEvents from "./components/homepage/CompoEvents";
import CompoCreations from "./components/homepage/CompoCreations";
import LabGrid from "./components/lab/Grid";
import ContactForm from "./components/ContactForm";
import SocialContact from "./components/SocialContact";
import MailMorph from "./components/MailMorph";
import RevealFadeX from "./fx/RevealFadeX";
import RevealFadeY from "./fx/RevealFadeY";
import RevealFade from "./fx/RevealFade";
import RevealFadeOut from "./fx/RevealFadeOut";
import RevealMask from "./fx/RevealMask";
import ContactView from "./view/ContactView";
import PageView from "./view/PageView";
// import LabView from './view/LabView';

const components = {
  Footer: Footer,
  HomeView: HomeView,
  SingleView: SingleView,
  VisionView: VisionView,
  // "LabView": LabView,
  LabGrid: LabGrid,
  ArticleCarousel: ArticleCarousel,
  ArticlesRelated: ArticlesRelated,
  Cover: Cover,
  TagsList: TagsList,
  PullquoteCustom: PullquoteCustom,
  QuoteVisual: QuoteVisual,
  IlluSide: IlluSide,
  IlluHighlight: IlluHighlight,
  CoverCreationsIndex: CoverCreationsIndex,
  CoverSavoirFaire: CoverSavoirFaire,
  CoverEvents: CoverEvents,
  CoverVision: CoverVision,
  CoverPeople: CoverPeople,
  GridFilter: GridFilter,
  TermsList: TermsList,
  CompoIntro: CompoIntro,
  PlayerVideo: PlayerVideo,
  CompoIntroHomepage: CompoIntroHomepage,
  RevealGridItem: RevealGridItem,
  RevealGridItemEvent: RevealGridItemEvent,
  RevealGridItemQuote: RevealGridItemQuote,
  Rail: Rail,
  RailHome: RailHome,
  RailLab: RailLab,
  DatesList: DatesList,
  VisionSlideshow: VisionSlideshow,
  VisionAccordion: VisionAccordion,
  LabHighlight: LabHighlight,
  PeopleHighlight: PeopleHighlight,
  CompoSavoirFaire: CompoSavoirFaire,
  CompoEvents: CompoEvents,
  CompoCreations: CompoCreations,
  ContactForm: ContactForm,
  SocialContact: SocialContact,
  RevealFadeX: RevealFadeX,
  RevealFadeY: RevealFadeY,
  RevealFade: RevealFade,
  RevealFadeOut: RevealFadeOut,
  RevealMask: RevealMask,
  ContactView: ContactView,
  PageView: PageView,
  MailMorph: MailMorph,
  VideoDetection: VideoDetection,
};

export default components;
